import React, { Fragment } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import DataPreloader from "@/components/DataPreloader/DataPreloader";

import WithContexts from "./components/AppContext/WithContexts";
import { CloneProgress } from "./components/CloneProgress/CloneProgress";
import CloneView from "./components/CloneView";
import SelectItems from "./components/SelectItems";
import { servicesConfig } from "./services/services-configs";

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
const { mondayService, oauthService } = servicesConfig();

function AppRouter() {
  return (
    <Fragment>
      {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
      <Router>
        <Switch>
          <Route path="/selectItems">
            <SelectItems />
          </Route>
          <Route path="/cloneProgress">
            <CloneProgress />
          </Route>
          <Route path="/">
            <DataPreloader />
            <WithContexts mondayService={mondayService} oauthService={oauthService}>
              <CloneView mondayService={mondayService} />
            </WithContexts>
          </Route>
        </Switch>
      </Router>
    </Fragment>
  );
}

export default AppRouter;
